import allapi from './api/api.js'
let APIS = {};
Object.assign(
    APIS,
    allapi
)
const getConfig = apiName => APIS[apiName];

export default getConfig;



// WEBPACK FOOTER //
// ./src/host/apiConfig.js